<template>
  <div :class="[!props.invert ? 'invert':'',]" class="transition-all duration-300">
    <DotLottieVue ref="ellieLogoLottie" class="aspect-[1/1]" autoplay loop :speed="0.5" src="/graphics/ellie_logo_new.lottie" />
  </div>
</template>

<script setup>
const props = defineProps({
  invert: {
    type: Boolean,
    default: false,
  },
});
const ellieLogoLottie = ref();
</script>

<style lang="scss">
#chatbot-lottie{}
</style>
